import React, { createContext, useContext, useState } from 'react';
import { IMedia } from '@/interfaces/media';

interface MediaContextType {
  media?: IMedia;
  setMedia: (item: IMedia | undefined) => void;
}

const MediaContext = createContext<MediaContextType | undefined>(undefined);

export const MediaProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [media, setMedia] = useState<IMedia | undefined>();
  return (
    <MediaContext.Provider value={{ media, setMedia }}>
      {children}
    </MediaContext.Provider>
  );
};

export const useMedia = (): MediaContextType => {
  const context = useContext(MediaContext);
  if (!context) {
    throw new Error('useMedia must be used within an MediaProvider');
  }
  return context;
};
